export class SelectedItem {
  isSelected: boolean;
  item: any;

  constructor(init: Readonly<SelectedItem>) {
    Object.assign(this, init);
  }
}
